import { randomColor } from '@chakra-ui/theme-tools'

import { FALLBACK_AVATAR } from '~config/constants'
import { UserBasicInfoFragment } from '~graphql/generated/graphql'

function isPlaceholderAvatarUrl(url: string): boolean {
    return (
        url.includes('default%20avatar.jpeg') ||
        url.includes('default avatar.jpeg')
    )
}

export function getAssigneeAvatarSrc(
    user?: Pick<UserBasicInfoFragment, 'avatar_url'> | null,
): string | undefined {
    if (!user) return FALLBACK_AVATAR

    const url = user.avatar_url?.trim()
    if (!url || isPlaceholderAvatarUrl(url)) return undefined

    return url
}

export function getAssigneeDisplayName(
    user?: Pick<UserBasicInfoFragment, 'first_name' | 'last_name'> | null,
): string | undefined {
    if (!user) return undefined

    const name = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim()
    return name || undefined
}

export function getAssigneeInitialsBg(
    user?: Pick<UserBasicInfoFragment, 'first_name' | 'last_name'> | null,
): string | undefined {
    const name = getAssigneeDisplayName(user)
    if (!name) return undefined

    // Chakra only sets the name-hash fill when the image is not loaded.
    // After a photo loads, `--avatar-bg` is left unset and the circle
    // falls back to white — so set the same hash explicitly.
    return randomColor({ string: name })
}
